<template>
    <div class="px-3" :class="{ 'form-control': !!assetClass }">
        <div class="d-flex" v-if="toggleActive">
            <div class="form-check me-2">
                <label class="form-check-label">
                    <input type="checkbox" id="checkbox-template" name="checkbox-template" v-model="isTemplate" />
                    <i class="input-helper"></i>
                </label>
            </div>
            <label for="checkbox-template"> <span class="me-2"><strong> {{$translate('activity_template_note')}}</strong></span></label>
        </div>
        <b-card class="mb-4" :title="title" title-tag="h6" v-if="isTemplate">
            <b-row>
                <b-col cols="12" md="4" class="mt-3 dd" v-if="includeOrderType && !isAsset">
                    <label class="mb-3"><strong>{{$translate('type')}}</strong></label>
                    <b-form-select class="form-control" id="input-type" v-model="order_type_id"
                        :options="orderTypes | mapOptions" :disabled="disabled">
                        <!-- :options="typeOptions || (orderTypes | mapOptions)" :disabled="disabled"> -->
                        <template #first>
                            <b-form-select-option :value="null">{{$translate('select_activity_type')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col cols="12" :md="(includeOrderType && !isAsset) ? 4 : 6" class="mt-3 dd">
                    <label class="mb-3"><strong>{{$translate('category')}}</strong></label>
                    <b-form-select class="form-control" id="input-category" v-model="category_id"
                        :options="categories | mapOptions" :disabled="disabled">
                        <template #first>
                            <b-form-select-option :value="null">{{$translate('select_category')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" :md="(includeOrderType && !isAsset) ? 4 : 6" class="mt-3 dd">
                    <label class="mb-3"><strong>{{$translate('template')}}</strong></label>
                    <b-form-select class="form-control" id="input-template" v-model="order_template_id"
                        :options="filteredTemplates | mapOptions" :disabled="disabled || !category_id">
                        <template #first>
                            <b-form-select-option :value="null">{{$translate('select_template')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            category_id: null,
            order_template_id: null,
            order_type_id: null,
            isTemplate: true,
        }
    },
    props: {
        toggleActive: {
            default: false,
            type: Boolean,
        },
        assetClass: {
            type: String,
        },

        title: {
            type: String,
        },

        value: {
            default: null,
            type: Number,
        },

        orderTypeId: {
            default: null,
            type: Number,
        },
        isAsset:{
            default:false,
            type:Boolean
        },
        includeOrderType: {
            default: false,
            type: Boolean,
        },
        includeItems: {
            default: false,
            type: Boolean,
        },

        disabled: {
            default: false,
            type: Boolean,
        },
    },
    filters: {
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
    },
    computed: {
        filteredTemplates() {
            console.log('abcbcb', this.templates)
            return this.templates.filter(
                x => x.order_category_id === this.category_id && x.items_count > 0
            )
        },
        filteredCategories() {
            const unique = (value, index, self) => {
                return self.indexOf(value) === index
            }
            const { categories } = this
            return this.templates
                .filter(x => x.order_type_id === this.order_type_id)
                .map(x => x.order_category_id)
                .filter(unique)
                .map(x => categories.find(y => y.id == x))
        },
        categories() {
            return this.$store.state.orderCategory.categories
        },
        templates() {
            return this.$store.state.orderTemplate.templates
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
        selectedTemplate() {
            return this.$store.state.orderTemplate.selectedTemplate
        },
    },

    watch: {
        category_id: function (val) {
            if(val == null){
                this.order_template_id = null
                this.order_type_id = null
            }
        },
        value: function (val) {
            this.setTemplate(val)
        },
        selectedTemplate: {
            handler: function (val) {
                this.$emit('set-items', val && val.items)
            },
            deep: true,
        },
        order_template_id: function (val) {
            this.$emit('input', val)
            if (this.includeItems)
                this.$store.dispatch('orderTemplate/fetchById', val)
        },
        orderTypeId: function (val) {
            console.log("orderTypeId", this.orderTypeId);
            this.order_type_id = val
        },
        isTemplate: function (val) {
            if (!val) this.order_template_id = null
        },
    },
    mounted() {
        console.log(this.orderTypeId, "orderTypeId");
        this.order_type_id = this.orderTypeId
        this.setTemplate(this.value)
    },
    created() {
        this.$store.dispatch('orderCategory/fetchAll')
        this.$store.dispatch('orderTemplate/fetchAll')
    },

    methods: {
        setTemplate(id) {
            const x = this.templates.find(x => x.id === id)
            console.log('template:', x)
            if (x) {
                this.order_type_id = x.order_type_id
                this.category_id = x.order_category_id
                this.order_template_id = id
            } else {
                this.order_type_id = null
                this.category_id = null
                this.order_template_id = null
            }
        },
    },
}
</script>
